import React from 'react'
import HeaderOne from "../components/header/HeaderOne";
import CallToActionThree from '../components/calltoaction/CallToActionThree';
import PrimaryFooter from '../components/footer/PrimaryFooter';
import AviationBreadcrumb from '../inner/AviationBreadcrumb';
import AviationSidebar from './AviationSidebar';

const ManpowerSupport = () => {
    const breadcrumbs = [
        { label: 'Home', link: '/' },
        { label: 'Manpower Support' }
    ];
  return (
    <>    
       
<div className=''>
<HeaderOne />
<AviationBreadcrumb title="Manpower Support" breadcrumbs={breadcrumbs} />




{/* start service details area */}
<div className="rts-service-details-area rts-section-gap">
    <div className="container">
        <div className="row">
        <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12">
                <div className="service-detials-step-1">
                    <div className="thumbnail">
                    <img src="assets/images/manpower-support.jpg" alt="Supply Chain Management" />
                    </div>
                   
                   </div>  
            </div>
            <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12">
                <AviationSidebar />
</div>



<div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 text-center">
<h4 className="title text-center"> Manpower Support  </h4>
                   <p className='pb-5'> “Skilled Aviation Professionals” At P.A.S. we provide top-tier aviation professionals to support your operations, including pilots, engineers, technicians, and ground staff. 
                    With a focus on reliability, expertise, and efficiency, we ensure you have the skilled workforce needed to meet the demands of the aviation industry.  </p>
            </div> 

            <div className="col-lg-4 col-md-4 col-12">
    <div className='description'>
     <h5>  Flight Crew & Pilot Recruitment </h5>
       <ul>
        <li> Certified commercial and private jet pilots. </li>
        <li> Cabin crew, flight attendants, and VIP service professionals. </li>
       </ul>
       </div> 
   </div>


   <div className="col-lg-4 col-md-4 col-12">
    <div className='description'>
     <h5> Aircraft Maintenance & Engineering Support </h5>
       <ul>
        <li> Licensed aircraft engineers (B1/B2), mechanics, and technicians. </li>
        <li> MRO (Maintenance, Repair & Overhaul) staffing for scheduled and unscheduled maintenance. </li>
       </ul>
       </div> 
   </div>



   <div className="col-lg-4 col-md-4 col-12">
    <div className='description'>
     <h5> Ground & Logistics Personnel </h5>
       <ul>
        <li> Baggage handlers, ground crew, and ramp operators. </li>
        <li> Aviation supply chain, logistics, and procurement specialists. </li>
       </ul>
       </div> 
   </div>



   <div className="col-lg-4 col-md-4 col-12">
    <div className='description'>
     <h5> Air Traffic & Airport Operations Staff </h5>
       <ul>
        <li> Air traffic controllers and airport management professionals. </li>
        <li> Customer service agents, operations coordinators, and terminal staff. </li>
       </ul>
       </div> 
   </div>



   <div className="col-lg-4 col-md-4 col-12">
    <div className='description'>
     <h5> Aviation Corporate & Administrative Roles </h5>
       <ul>
        <li> Airline executives, HR, finance, and IT specialists. </li>
        <li> Compliance officers, safety managers, and regulatory consultants. </li>
       </ul>
       </div> 
   </div>



        </div>


        <div className="row mt-5">
            <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                <div className="service-detials-step-1">
                    <div className="thumbnail">
                        <img src="assets/images/manpower-support.jpg" alt="Supply Chain Management" />
                    </div>
                   </div>  
            </div>

            <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
                <div className="service-detials-step-1 industries">
                    <h4 className="title"> Why Choose Planetronix Manpower Support? </h4>
                    <ul>
                        <li><b>  Certified & Experienced Professionals </b>  Industry-trained aviation personnel. </li>
                        <li> <b>  Flexible Staffing Solutions </b> Short-term, long-term, and contract hiring. </li>
                        <li><b>  Global Network </b> Manpower support for international aviation businesses. </li>
                        <li><b>  Fast & Reliable Hiring Process </b> Quick deployment of skilled aviation staff. </li>
                    </ul>
                </div>  
            </div>
        </div>
    </div>
</div>
{/* End service details area */}





<CallToActionThree />

<PrimaryFooter />
</div>    
   

    
    
    </>
  )
}

export default ManpowerSupport